import { useEffect, useState } from "react";
import DataTable from "../../component/DataTable";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import AdminHeader from "../../component/AdminHeader";
import ApiRequest from "../../helper/ApiRequest";
import { ApiEndpoints } from "../../helper/ApiEndpoints";

const deleteEndpoint = ApiEndpoints.dynamicPage.Delete;
const listEndpoint = ApiEndpoints.dynamicPage.List;
const pressEditPath = "edit-dynamic-page";
const tableHeader = ["Date","Title","Slug"];
const tbody = ["createdAt","title","slug"];

export default function DynamicPage() {

  const [data, setData] = useState([]);

  const dataFetch = async () => {
    try {
      const response = await ApiRequest("GET", listEndpoint);
      const result = response.data;
      setData(result);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => { 
    dataFetch();
  }, []);

  const handleDelete = async (id) => {
      const payload = { id };
      try {
        const response = await ApiRequest("POST", deleteEndpoint, payload);
        toast.success(response.message)
        dataFetch();
      } catch (error) {
        console.error(error);
      }
    };

    const pagename = {
      name: 'Dynamic Page Management',
      user: 'Admin',
      innerpage: 'Dynamic Page Management / Dynamic Pages'
    }

  return (
    <>
    <AdminHeader pagename={pagename}/>

      <div className="add-btn-section">
        <Link className="admin-add-btn" to="/add-dynamic-page">Add +</Link>
        <DataTable
          data={data}
          tableHeader={tableHeader}
          tbody={tbody}
          editPath={pressEditPath}
          onDelete={handleDelete}
        />
      </div>
    </>
  );
}
